import { types } from '../types/types';


const initialState = {
    editingDgiiCert: {
        id: 0,
        validFrom: "",
        validUntil: "",
        realmFk: "",
        fileName: "",
        certificate: "",
        privateKey: "",
        status: true
    },
};

export const dgiiCertReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingDGIICertInfo:
            return {
                ...state,
                editingDgiiCert: action.payload,
            };

        case types.clearDGIICertInfo:
            return {
                ...state,
                editingDgiiCert: initialState.editingUser,
            };

        default:
            return state;
    }
};